import defer from 'lodash/defer'
import { useCallback, type RefObject } from 'react'
import { useIsOpen } from 'shared/hooks'
import type { ParentRefProps } from '../DataField/types'

type UseFieldQrScanParams = {
  inputRef: RefObject<HTMLInputElement>
  parentRef: RefObject<ParentRefProps>
  enableQRCodeReader?: boolean
}

export const useFieldQrScan = ({
  inputRef,
  parentRef,
  enableQRCodeReader
}: UseFieldQrScanParams) => {
  const { isOpen, close: qrClose, open: qrOpen } = useIsOpen()

  const onScanSuccess = useCallback(
    (content?: string) => {
      if (content) {
        parentRef.current?.onChangeInputValue?.(content)
        defer(() => {
          inputRef.current?.focus()
        })
      }
      qrClose()
    },
    [inputRef, parentRef, qrClose]
  )

  return {
    qr: {
      isOpen,
      open: qrOpen,
      close: qrClose,
      enableQRCodeReader
    },
    onScanSuccess
  }
}
